import { useEffect, useState } from 'react';
import { api } from '../utils/api';

const EMPTY = {
  rating: 0,
  reviewCount: 0,
  reviews: [],
  landingPageUrl: '',
  isLive: false,
  loaded: false,
};

export function useGoogleReviewsFeed() {
  const [data, setData] = useState(EMPTY);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/content/google-reviews');
        if (cancelled) return;
        setData({
          rating: Number(res.rating) || 0,
          reviewCount: Number(res.reviewCount) || 0,
          reviews: Array.isArray(res.reviews) ? res.reviews : [],
          landingPageUrl: String(res.landingPageUrl || '').trim(),
          isLive: Boolean(res.isLive),
          loaded: true,
        });
      } catch {
        if (!cancelled) setData((prev) => ({ ...prev, loaded: true }));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return data;
}

export function formatGoogleReviewStars(rating) {
  const rounded = Math.min(5, Math.max(0, Math.round(Number(rating) || 0)));
  return '★'.repeat(rounded) + '☆'.repeat(5 - rounded);
}

export function formatGoogleReviewSummary(rating, reviewCount) {
  const r = Number(rating) || 0;
  const count = Number(reviewCount) || 0;
  if (r <= 0 || count <= 0) return 'Rating not available';
  const displayRating = r % 1 === 0 ? r.toFixed(1) : r.toFixed(1);
  return `${displayRating} on Google (${count.toLocaleString('en-KE')} Reviews)`;
}
